// tr strings for messages/home.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const home: Dict = {
  "home.seo.title": "Jammable | En Sevdiğin Seslerle AI Cover Yap!",
  "home.seo.description":
    "Jammable ile saniyeler içinde yapay zeka cover yap. Topluluğun yüklediği binlerce yapay zeka ses modeli yaratıcı kullanımın için hazır!",
  "home.seo.ogTitle":
    "Jammable | En Sevdiğin Seslerle AI Cover Yap | Yapay Zeka ile Müzik Üretimi",
  "home.seo.imageAlt": "Jammable - AI Cover Yap",

  // Word order: "En sevdiğin seslerle <AI cover> oluştur".
  "home.hero.views": "TikTok, YouTube ve Instagram'da 10 milyar+ izlenme",
  "home.hero.titleBefore": "En sevdiğin seslerle",
  "home.hero.titleHighlight": "AI cover",
  "home.hero.titleAfter": "oluştur",
  "home.hero.subtitle":
    "100.000+ yapay zeka sesinden birini seç, kaydını ekle ve saniyeler içinde geri al.",
  "home.hero.decorVoice": "yapay zeka sesi",
  "home.hero.decorCover": "cover",
  "home.hero.searchLabel": "Ses ara",
  "home.hero.searchPlaceholder": "100.000+ ses arasında ara",
  "home.hero.searchButton": "Ara",
  "home.hero.makeCover": "Cover yap",

  "home.categories.all": "Tüm kategorileri gör",
  "home.recent": "Kaldığın yerden devam et",
  "home.trending": "Şu an trend",
  "home.seeAll": "Tümünü gör",

  // "Kendi yapay zeka <sesini eğit>"
  "home.train.kicker": "100.000+ ses böyle başladı",
  "home.train.titleBefore": "Kendi yapay zeka",
  "home.train.titleHighlight": "sesini eğit",
  "home.train.body":
    "Birkaç örnekten bir ses oluştur, sonra kimsede olmayan bir sesle cover yap.",
  "home.train.step1": "Örneklerini yükle",
  "home.train.step1Sub": "Net vokallerden oluşan kısa bir kayıt yeterli",
  "home.train.step2": "Modelini biz eğitiriz",
  "home.train.step2Sub": "Özel sesin dakikalar içinde hazır",
  "home.train.step3": "Onunla cover yap",
  "home.train.step3Sub": "Cover'larında istediğin zaman kullan",

  "home.topCollections": "En iyi koleksiyonlar",
  "home.collabs": "Trend düetler",
  "home.collection": "Koleksiyon",

  "home.card.uses": "{n} kullanım",
  "home.card.voices": "{n} ses",
  "home.card.likes": "{n} beğeni",
  "home.card.by": "@{user} tarafından",
  "home.card.madeToday": "Bugün {n} yapıldı",
  "home.card.makeDuet": "Bu düeti yap",

  "home.discord.bannerSub": "Cover paylaş, ses iste ve topluluktan yardım al",
  "home.discord.online": "{n} çevrimiçi",
  "home.discord.members": "{n} üye",
  "home.discord.joinDiscord": "Discord'a katıl",
  "home.discord.softSub": "Cover paylaş, ses iste, ipuçları al",
  "home.discord.cardSub": "Yardım al, cover paylaş, yeni sesler keşfet",
  "home.discord.join": "Katıl",
};

export default home;
